/**
 * Same-page hash links preventDefault + scroll (theme.js) without closing
 * open nav. Close dropdowns / sidebar when that simulated hash change fires.
 */
document.documentElement.addEventListener("hashchange:simulate", () => {
  document
    .querySelectorAll("dropdown-menu-disclosure:has(details[open]), mega-menu-disclosure:has(details[open])")
    .forEach((menu) => menu.toggle(false));

  document.querySelector("header-sidebar[open]")?.hide();
});
